import { Modal, ModalContent, ModalOverlay, ModalProps } from "@chakra-ui/react";

export const ModalLayout: React.FC<ModalProps> = (properties) => {
  return (
    <Modal isCentered {...properties} data-testid="modal" motionPreset="none">
      <ModalOverlay backdropFilter="blur(6px)" />
      <ModalContent pb="2" w={{ base: "95%", md: "100%" }}>
        {properties.children}
      </ModalContent>
    </Modal>
  );
};
